import { AppLauncherConfig, FnNext, OpenContext } from '../types';
import { createWechatLaunchStrategy } from '../strategy/wechat';
import axios from 'axios';
import { createQQLaunchStrategy } from '../strategy/qq';
import jsonpAdapter from 'axios-jsonp';
import { Launcher } from '../util/launcher';
import { IS_ANDROID, IS_IOS, IS_IPHONE, IS_QQ_VIDEO } from '../util/ua';

const getAppVersion = () => {
  interface Rsp {
    data?: Array<{ update_version: string }>;
    code: string | number;
  }
  return axios
    .get<Rsp | undefined>('//node.video.qq.com/x/api/wuji_cache/object?'
+ 'appid=video_update_conf&schemaid=t_android_update&schemakey=f8851c5a3da8442dabc8948764543e96&filter=id%3D1377&include=update_version')
    .then(result => result.data?.data?.[0].update_version ?? '8.3.64');
};

const protocol = IS_IOS ? 'tenvideo2' : 'txvideo';

export const TEN_VIDEO_CONFIG: AppLauncherConfig = {
  model: {
    confid: '20449',
  },
  intent: {
    package: 'com.tencent.qqlive',
  },
  scheme: {
    protocol: 'txvideo',
    host: 'v.qq.com',
    path: '/HomeActivity',
  },
  beforeLaunch(context) {
    const ctx = context;
    // from的值来自于参数里的from或者model里的confid或者location.pathname
    ctx.params.from = ctx.params.from ?? ctx.model.confid ?? window.location.pathname?.replace(/\//g, '');
    // from有值，设置model的confid为from的值
    ctx.params.from ? ctx.model.confid = ctx.params.from : void 0;
    return ctx;
  },
  fallback({ params }) {
    if (IS_IOS) {
      // ios设备跳转app store就行了
      if (IS_IPHONE) {
        return 'http://itunes.apple.com/cn/app/id458318329?mt=8';
      }
      return 'https://itunes.apple.com/cn/app/teng-xun-shi-pinhd/id407925512?mt=8';
    }
    if (IS_ANDROID) {
      // 安卓
      return `DOWNLOAD:http://mcgi.v.qq.com/commdatav2?cmd=4&confid=${params.from}&platform=aphone`;
    }
    // pc
    return 'https://v.qq.com/download.html';
  },
  customLaunch: [
    /**
     * 在App内的话直接拉起就好了
     */
    function inAppStrategy(context: OpenContext, launcher: Launcher, next: FnNext): Promise<boolean> {
      if (IS_QQ_VIDEO) {
        return launcher.launchByLocation(context.schemeUrl);
      }
      return next();
    },
    createWechatLaunchStrategy({
      packageName: 'com.tencent.qqlive',
      packageUrl: `${protocol}://`,
      appID: 'wxca942bbff22e0e51',
      downloader: {
        developer: '腾讯公司',
        permissionUrl: 'https://dldir1.qq.com/weixin/android/wechat_webview_download_appinfo_new.html?fun=permission&package=com.tencent.qqlive',
        privacyAgreementUrl: 'https://m.v.qq.com/about/privacy-policy.html',
        getAppVersion,
        icon: 'http://i.gtimg.cn/qqlive/images/20150608/logo_app.png',
        name: '腾讯视频',
        getConfid: context => context.model.confid as string ?? '',
        async getMd5(context) {
          const res = await axios.get<{ md5: string}>(
            `//mcgi.v.qq.com/commdatav2?cmd=39&confid=${context.model.confid ?? ''}`,
            { adapter: jsonpAdapter },
          );
          return res.data.md5;
        },
      },
    }),
    createQQLaunchStrategy({
      packageName: 'com.tencent.qqlive',
      packageUrl: `${protocol}://`,
      downloader: {
        appid: '100730521',
        via: 'ANDROID.QQLIVE',
        getConfid: context => context.model.confid as string ?? '',
      },
    }),
  ],
};
